import { logger } from '@/lib/logger';

export const registerPageLifecycleTracking = (): (() => void) => {
  const handleVisibilityChange = (): void => {
    const isHidden = document.visibilityState === 'hidden';
    logger.fpti(
      'page_lifecycle_visibility_change',
      {
        event_name: 'page_lifecycle_visibility_change',
        state_name: 'checkout_page',
        transition_name: isHidden
          ? 'process_page_hidden'
          : 'process_page_visible',
        visibility_state: document.visibilityState,
      },
      isHidden, // flush immediately when hidden — logs could be lost on unload
    );
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
